import endpoint from '../../app_configuration/apiEndpoints/cmsEndpoints';

const toggleHolidayClient = async (holiday) => {
    const url = `${process.env.REACT_APP_PUBLIC_ECOMM_URL}${endpoint.toggleHoliday()}`;

    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(holiday),
    });

    if (!res.ok) {
        return { error: true, message: 'toggle holiday request failed', status: res.status, data: [] };
    }
    const getData = await res.json();
    return { status: res.status, data: getData };
};

export default toggleHolidayClient;
